import React, {Fragment} from "react";
import Language from 'services/Language.js';

class Status extends React.Component {
    constructor(props) {
        super(props);
    }

    renderStatus() {
        if (this.props.status >=0 && this.props.status < 36) {
            return <div className="crypto-history-checks-item__status-low">
                {this.props.status} ({Language.getLabel('L_CRYPTO_WALLETDESC_STATUS_2')})
            </div>
        }
        if (this.props.status > 35 && this.props.status < 76) {
            return <div className="crypto-history-checks-item__status-medium">
                {this.props.status} ({Language.getLabel('L_CRYPTO_WALLETDESC_STATUS_3')})
            </div>
        }
        if (this.props.status > 75) {
            return <div className="crypto-history-checks-item__status-high">
                {this.props.status} ({Language.getLabel('L_CRYPTO_WALLETDESC_STATUS_1')})
            </div>
        }
    }

    render() {
        return (
            <Fragment>
                {this.props.status === null ?
                    <div className="crypto-history-checks-item__status-low">
                        {Language.getLabel('L_ADDRESS_IS_BEING_CHECKED')}
                    </div>
                    :
                    this.renderStatus()
                }
            </Fragment>
        )
    }
}

export default Status